import { Preferences } from "@capacitor/preferences";

export const getPreference = async (key: string): Promise<string | null> => {
  const { value } = await Preferences.get({ key });
  return value;
};

export const setPreference = async (
  key: string,
  value: string
): Promise<void> => {
  await Preferences.set({
    key,
    value,
  });
};

export const removePreference = async (key: string): Promise<void> => {
  await Preferences.remove({ key });
};
